







import { gql } from 'graphql-tag';
import { Component, mixins } from 'nuxt-property-decorator';

import { blockableBlockColorFragment, blockColorMixin } from '@/composables/block-color';

import { ImageBlockDataFragment } from '@/graphql/generated';
import { PageBlockMixin } from '@/modules/cms';
import { largeImageFragment } from '@/graphql/queries/image.fragments';

@Component({
  graphqlData: gql`
    fragment ImageBlockData on ImageBlock {
      image {
        ...LargeImageData
      }
      ...BlockColor
    }

    ${largeImageFragment}
    ${blockableBlockColorFragment}
  `,
})
export default class ImageBlock extends mixins(PageBlockMixin<ImageBlockDataFragment>(), blockColorMixin) {}
